import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { CModal, CModalHeader, CModalBody, CModalTitle, CButton } from '@coreui/react';
import { BsArrowRight, BsArrowBarDown } from 'react-icons/bs';
import { useParams, useNavigate } from 'react-router-dom';
import { jsPDF } from 'jspdf';
import { toast } from 'react-toastify';
import html2canvas from 'html2canvas';
import api from '../../../service/caller';
import Lg from '../../clientviews/telemedecine/image/LG1.png';
import '../../clientviews/telemedecine/appointment/ordornance.css';
import { identity } from '@fullcalendar/core/internal';
import { usePermissions } from '../../../contexts/PermissionContext';



const BillingTicket = () => {
    const { id } = useParams();  // Récupérer l'ID du rdv
    const [patientData, setPatientData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const [appointment, setAppointment] = useState(null);
    const [billing, setBilling] = useState(null);
    const { UserData } = usePermissions()

    // recuperer appointment
    useEffect(() => {
        const fetchAppointment = async () => {
            try {
                const res = await api.get(`/clinic/getappointment/${id}`);
                setAppointment(res.data.appointment);
                console.log('aptdate', res.data);
            } catch (err) {
                console.error('Erreur lors du chargement du rendez-vous', err);
            }
        };

        fetchAppointment();
    }, [id]);

    // recuperer billing en fonction du rdv


    useEffect(() => {
        if (!identity) return;

        api.get(`clinic/billing/appointment/${id}`)
            .then(res => {
                setBilling(res.data);
                console.log('dato', res.data);
            })
            .catch(err => {
                console.error(err);
                setError(err.response?.data?.message || 'Erreur lors de la récupération de la facture.');
            });
    }, [id]);

    if (!appointment) return <div>Chargement...</div>;

    // Fonction pour récupérer les données du patient
    // useEffect(() => {
    //     const fetchPatientData = async () => {
    //         try {
    //             const response = await api.get(`/clinic/getpatient/${patientId}`);  // Remplacer par votre API
    //             setPatientData(response.data);
    //             setLoading(false);
    //         } catch (error) {
    //             console.error('Erreur lors de la récupération des données du patient', error);
    //             setError('Erreur lors de la récupération des données.');
    //             setLoading(false);
    //         }
    //     };

    //     if (patientId) {
    //         fetchPatientData();
    //     }
    // }, [patientId]);  

    const handleDownload = async () => {
        const element = document.querySelector('.ticketpayment');
        if (!element) return;

        try {
            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                backgroundColor: '#ffffff'
            });

            const imgData = canvas.toDataURL('image/jpeg', 1.0);
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4'
            });

            const imgWidth = 210; // A4 width
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
            pdf.save(`billingticket_${id}.pdf`);
        } catch (error) {
            console.error('Erreur de génération PDF:', error);
        }
    };

    return (
        <>
            <div className="ordonnance-container position-relative maindiv ">
                <div className='ticketpayment'>
                    <div className="">
                        <div className="d-flex justify-content-between">
                            <div>
                                <img src={UserData.hospital_id[0].picture || Lg} alt="logo" className="img-fluid w-100" />
                            </div>
                            <div className="text-end mt-2">
                                <p style={{ fontSize: '13px' }}><strong>CLINIQUE POLYVALENTE OLUWA SHEYI</strong></p>
                                <p style={{ fontSize: '13px', marginTop: '-.7rem' }}>06 B.P. 2102 COTONOU - </p>
                                <p style={{ fontSize: '13px', marginTop: '-.7rem' }}>CEL: (+229) 55 42 99 99 / 52 47 54 54</p>
                            </div>
                        </div>
                    </div>
                    <h3 className="text-center mt-5 mb-5" style={{ color: '#043972', fontSize: '20px' }}>Billing Ticket</h3>
                    <div className="immole d-flex flex-column justify-content-center align-items-center">
                        <div className="text-start">
                            <p>Veuillez passer a la caisse avec ce numero <strong> Numéro Payment : </strong><strong style={{ color: 'green' }}> {billing?.paymentuniqueId}</strong> pour effectuer votre payement</p>
                            <p><strong>Appointment Code: </strong> {appointment?.AppointmentCode}</p>
                            <p><strong>Patient: </strong>{billing?.patientId.firstname} {billing?.patientId.lastname} </p>
                            <p><strong>Motif: </strong> {appointment?.motif}</p>
                            <p>
                                <strong>Type Consultation: </strong>{' '}
                                {appointment?.type_consultation === 'inperson'
                                    ? 'Consultation en personne'
                                    : 'Télémedecine'}
                            </p>
                            <p><strong>Department: </strong>{billing?.department.name}</p>
                            <p><strong>Price: </strong> {appointment?.price} FCFA</p>
                            <p><strong>Notes: </strong> {appointment?.notes}</p>

                        </div>
                    </div>
                    <div className="mt-4 scurr">
                        <div className="px-5">
                            <p className="text-center" style={{ fontSize: '14px', color: '#043972' }}>Prière de rapporter l'ordonnance à toute consultation ultérieure et prévenir 48h à l'avance pour annuler tout rendez-vous. Merci.</p>
                        </div>
                        <span className="d-block" style={{ borderBottom: '4px solid #14AC89' }}></span>
                        <p className="text-center mt-3" style={{ fontSize: '14px', color: '#043972' }}>
                            06 B.P. 2102 COTONOU - CEL: (+229) 55 42 99 99 / 52 47 54 54
                        </p>
                        <p className="text-center mt-3" style={{ fontSize: '14px', color: '#043972' }}>
                            N° IFU 3202378655640 - RCCM RB/COT/23 B 34365 DU 26/01/2023
                        </p>
                    </div>
                </div>
            </div>
            <div className='p-5 btnactionpatientcard' >
                <CButton className="w-100" style={{ backgroundColor: '#FF9800' }} onClick={handleDownload} >
                    Telecharger<BsArrowBarDown className='ms-2' />
                </CButton>
                <CButton className="w-100" style={{ backgroundColor: '#28A745' }} >
                    Fermer <BsArrowRight className='ms-2' />
                </CButton>
            </div>
        </>

    );
};
export default BillingTicket;